import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { createRoomCategory, updateRoomCategory } from "services/CategoryService";
import { getRoomTypes } from "services/RoomTypeService";

import { getHotels } from "services/HotelService";
const RoomCategoryForm = () => {
  const [hotel_id, setHotelName] = useState("");
  const [room_type, setRoomType] = useState("");
  const [hotels, setHotels] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [roomTypes, setRoomTypes] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  
  const { isEdit, editFormData } = location.state || {
      isEdit: false,
      editFormData: {},
    };

  useEffect(() => {
    getHotelsList();
    getRoomTypeList();
  }, []);

 useEffect(() => {
      if (isEdit && editFormData) { 
        setRoomType(editFormData.room_type);
        setHotelName(editFormData.hotel_id);      
            
      }
    }, [isEdit, editFormData]);
  const getHotelsList = (state = null) => {
    getHotels(state).then((response) => {
      if (response && response.data.success) {
        setHotels(response.data.hotels);
      }
    });
  };

  const getRoomTypeList = () => {
        getRoomTypes().then((response) => {
          if (response && response.data.success) {
            setRoomTypes(response.data.roomTypes);           
          }
        });
      };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      hotel_id,
      room_type,
    };

    try {
      setErrors({});
      setLoading(true);

      let response;
      if (isEdit) {
        response = await updateRoomCategory(payload, editFormData.id);
      } else {
        response = await createRoomCategory(payload);
      }

      setLoading(false);
      if (response?.data?.success) {
        navigate("/room-categories");
      } else if (response?.data?.errors) {
        const serverErrors = {};
        for (const field in response.data.errors) {
          serverErrors[field] = response.data.errors[field][0];
        }
        setErrors(serverErrors);
      }
    } catch (error) {
      console.error("Error adding booking:", error);
    }
  };
  return (
    <>
      <section className="content-header">
        <div className="header-icon">
          <i className="fa fa-hotel"></i>
        </div>
        <div className="header-title">
          <h1>Room Category</h1>
          <small>Add Room Category</small>
        </div>
      </section>
      <section className="content">
        <div className="row">
          <div className="col-sm-12">
            <div
              className="card lobicard all_btn_card"
              id="lobicard-custom-control1"
              data-sortable="true"
            >
              <div className="card-header all_card_btn">
                <div className="card-title custom_title">
                  <Link className="btn btn-add" to="/room-categories">
                    <i className="fa fa-list"></i> RoomCategorys List{" "}
                  </Link>
                </div>
              </div>
              <div className="card-body">
                <form className="col-sm-12" onSubmit={handleSubmit}>
                  <div className="row">
                    {/* Hotel Name */}
                    <div className="col-lg-5 col-md-6 mb-3">
                      <div className="form-group">
                        <label>Select Hotel Name</label>
                        <select
                          id="Hotelselect"
                          className="form-control"
                          value={hotel_id}
                          onChange={(e) => setHotelName(e.target.value)}
                          required
                        >
                          <option value="">Select Hotel</option>
                          {hotels.map((hotel) => (
                            <option value={hotel.id}>{hotel.name}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Room Type */}
                    <div className="col-lg-5 col-md-6 mb-3">
                      <div className="form-group">
                        <label>Room Type</label>
                        <select
                          className="form-control"
                          value={room_type}
                          onChange={(e) => setRoomType(e.target.value)}
                          required
                        >
                          <option value="">Select Room Type</option>
                          {roomTypes.map((type) => (
                            <option value={type.room_type}>{type.room_type}</option>
                          ))}
                         
                        </select>
                      </div>
                    </div>

                    {/* Submit */}
                    <div className="col-lg-2 col-md-6">
                      <div className="reset-button">
                        <button
                          type="submit"
                          className="btn btn-success"
                          disabled={loading}
                        >
                          {loading ? "Saving..." : "Save"}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default RoomCategoryForm;
